import { render, staticRenderFns } from "./writeoffStatistics.vue?vue&type=template&id=2c7ae5f2&scoped=true&"
import script from "./writeoffStatistics.vue?vue&type=script&lang=ts&"
export * from "./writeoffStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./writeoffStatistics.vue?vue&type=style&index=0&media=screen&lang=scss&"
import style1 from "./writeoffStatistics.vue?vue&type=style&index=1&id=2c7ae5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ae5f2",
  null
  
)

export default component.exports